import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Paper, Typography, TextField, Button, Stack, Link } from '@mui/material';

const ForgotPasswordPage: React.FC = () => {
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: '#f4f6f8',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
      }}
    >
      <Paper elevation={3} sx={{ p: 4, width: '100%', maxWidth: 420 }}>
        <Typography variant="h5" fontWeight={600} mb={1.5}>
          Reset your password
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={3}>
          Enter the email address associated with your account and we&apos;ll send you a reset link.
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate>
          <Stack spacing={2.5}>
            <TextField label="Email" type="email" required fullWidth autoComplete="email" />
            <Button type="submit" variant="contained" size="large">
              Send reset link
            </Button>
            <Typography variant="body2" textAlign="center">
              Remembered your password?{' '}
              <Link component={RouterLink} to="/login" underline="hover">
                Go back to login
              </Link>
            </Typography>
          </Stack>
        </Box>
      </Paper>
    </Box>
  );
};

export default ForgotPasswordPage;
